import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";

class CreativesDataStore extends EventEmitter {
	constructor() {
		super();

		this.creatives = {
			data: [],
			config: [],
			errors: []
		};

		/*
        Need to register all actions with the AppDispatcher
        */

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.fetchCreatives:
					const hierarchyData = action.value.data;
					hierarchyData.forEach((dataField) => {
						if (dataField.TaxonomyData) {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (dataField[dataTaxonomyField.DataKeyShortDescr.split(" ").join("")]) {
									action.value.config.TaxonomyData.forEach((configTaxonomyField) => {
										if (
											configTaxonomyField.ID === dataTaxonomyField.DataKeyID &&
											configTaxonomyField.Name !== dataTaxonomyField.DataKeyShortDescr.split(" ").join("")
										) {
											dataField[configTaxonomyField.Name] = dataField[dataTaxonomyField.DataKeyShortDescr.split(" ").join("")];
										}
									});
								}
							});
						}
						if (dataField.MetaData) {
							JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
								if (dataField[dataMetaDataField.DataKeyShortDescr.split(" ").join("")]) {
									action.value.config.MetaData.forEach((configMetaDataField) => {
										if (
											configMetaDataField.ID === dataMetaDataField.DataKeyID &&
											configMetaDataField.Name !== dataMetaDataField.DataKeyShortDescr.split(" ").join("")
										) {
											dataField[configMetaDataField.Name] = dataField[dataMetaDataField.DataKeyShortDescr.split(" ").join("")];
										}
									});
								}
							});
						}
					});
					this.creatives.config = action.value.config;
					this.creatives.data = hierarchyData;
					this.emit("creatives_loaded");
					break;
				case AppActionConstants.updateCreativesSuccess:
					this.creatives.data = [...this.creatives.data, action.value];
					this.emit("creatives_success");
					break;
				case AppActionConstants.updateCreativesFail:
					const errorObject = {};
					if (action.value.InputErrors) {
						action.value.InputErrors.forEach((error) => {
							Object.keys(error).forEach((errorName) => {
								errorObject[errorName] = error[errorName];
							});
						});
					}
					if (action.value.Errors) {
						errorObject.Errors = [action.value.Errors];
					}
					this.creatives.errors = errorObject;
					this.emit("creatives_fail");
					break;
				case AppActionConstants.createAndAddCreativeSuccess:
					this.creatives.data = [...this.creatives.data, action.value];
					this.emit("create_and_add_creatives_success");
					break;
				case AppActionConstants.editCreativesSuccess:
					if (action.value) {
						this.creatives.data.splice(
							this.creatives.data.findIndex((creative) => creative.UniqueID === action.value.UniqueID),
							1,
							action.value
						);
						this.creatives.data = [...this.creatives.data];
						this.emit("creatives_edit_success");
					} else {
						this.emit("creatives_edit_fail");
					}
					break;
				case AppActionConstants.editCreativesFail:
					const editErrorObject = {};
					if (action.value.InputErrors) {
						action.value.InputErrors.forEach((error) => {
							Object.keys(error).forEach((errorName) => {
								editErrorObject[errorName] = error[errorName];
							});
						});
					}
					if (action.value.Errors) {
						editErrorObject.Errors = [action.value.Errors];
					}
					this.creatives.errors = editErrorObject;
					this.emit("creatives_edit_fail");
					break;
				case AppActionConstants.deleteCreative:
					this.creatives.data = this.creatives.data.filter((creative) => {
						return !action.value.includes(creative.CreativeID);
					});
					this.emit("creative_deleted");
					break;
				case AppActionConstants.duplicateCreative:
					this.emit("duplicate_creative_success");
					break;
				case AppActionConstants.duplicateCreativeFail:
					this.emit("duplicate_creative_fail");
					break;
				default:
					break;
			}
		});
	}

	/*
    Getter function to return the current state
    */
	getData = () => this.creatives.data;
	getConfig = () => this.creatives.config;
	getErrors = () => this.creatives.errors;

	resetCreativesErrors = () => {
		this.creatives.errors = [];
		this.emit("creative__errors__reset");
	};

	resetCreativesData = () => {
		this.creatives.config = [];
	};
}

export default new CreativesDataStore();
